export const MicrosoftIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		height='18'
		viewBox='0 0 24 24'
		width='18'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<path
			d='M0 0h11.377v11.372H0z'
			fill='#f25022'
		/>
		<path
			d='M12.623 0H24v11.372H12.623z'
			fill='#00a4ef'
		/>
		<path
			d='M0 12.628h11.377V24H0z'
			fill='#7fba00'
		/>
		<path
			d='M12.623 12.628H24V24H12.623z'
			fill='#ffb900'
		/>
	</svg>
)
